module.exports = __webpack_public_path__ + "img/order.645b844f.png";